'use client'

import { IPlant } from "@/models/types/plant";
import { PlantFormType } from "../plantFields";
import PlantIndoorOutdoor, { PlantName, PlantPhotoUpload } from "./plantFieldsComps";

const formatDate = (value: Date | string | null | undefined) => {
    if (!value) {
        return 'Not scheduled';
    }

    return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }).format(new Date(value));
}

export default function FirstSection({ plantForm, widthQuery, plant, heightQuery }: { plantForm: PlantFormType, widthQuery: number, plant: IPlant, heightQuery: number }) {
    const schedule = plantForm.getValues().plant.careSchedule;
    const sunlight = plantForm.getValues().plant.sunlight?.requirement ?? 'Light not set';
    const water = plantForm.getValues().plant.waterFrequency ?? 'Water rhythm not set';
    
    return (
        widthQuery < 768 ? (
            <aside className="flex flex-col gap-4 rounded-md border border-emerald-900/10 bg-white p-4 shadow-sm">
                <PlantPhotoUpload plantForm={plantForm} />
                <PlantName plantForm={plantForm} heightQuery={heightQuery} />
                <PlantIndoorOutdoor plantForm={plantForm}/>
            </aside>
        ) : (
            <aside className="flex flex-col gap-4 rounded-md border border-emerald-900/10 bg-white p-4 shadow-sm">
                <PlantPhotoUpload plantForm={plantForm} />
                <div className="space-y-3">
                    <PlantName plantForm={plantForm} heightQuery={heightQuery}/>
                    <PlantIndoorOutdoor plantForm={plantForm} />
                </div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                    <div className="rounded-md bg-emerald-50 p-3">
                        <p className="text-xs font-medium uppercase text-emerald-900/60">Next Water</p>
                        <p className="font-semibold text-emerald-950">{formatDate(schedule?.nextWateringAt)}</p>
                    </div>
                    <div className="rounded-md bg-sky-50 p-3">
                        <p className="text-xs font-medium uppercase text-sky-900/60">Light</p>
                        <p className="font-semibold text-sky-950">{sunlight}</p>
                    </div>
                    <div className="col-span-2 rounded-md bg-lime-50 p-3">
                        <p className="text-xs font-medium uppercase text-lime-900/60">Watering</p>
                        <p className="font-semibold text-lime-950">{water}</p>
                    </div>
                </div>
                {plant.name && <p className="text-center text-lg font-semibold text-emerald-950">{plant.name}</p>}
            </aside>
        )

    );
}
